import { computed } from 'vue'

import DOMPurify from 'dompurify'
import MarkdownIt from 'markdown-it'

// Module-level singleton — shared across all component instances
const md = new MarkdownIt({
  html: false,
  linkify: true,
  breaks: true,
})

// Open links in new tab
const defaultRender =
  md.renderer.rules.link_open ||
  function (tokens, idx, opts, _env, self) {
    return self.renderToken(tokens, idx, opts)
  }

md.renderer.rules.link_open = function (tokens, idx, opts, env, self) {
  tokens[idx].attrSet('target', '_blank')
  tokens[idx].attrSet('rel', 'noopener noreferrer')
  return defaultRender(tokens, idx, opts, env, self)
}

const ALLOWED_TAGS = [
  'p',
  'br',
  'strong',
  'b',
  'em',
  'i',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'ul',
  'ol',
  'li',
  'table',
  'thead',
  'tbody',
  'tr',
  'th',
  'td',
  'code',
  'pre',
  'a',
  'blockquote',
  'hr',
]

const ALLOWED_ATTR = ['href', 'target', 'rel']

export function renderMarkdown(raw: string): string {
  const html = md.render(raw)
  return DOMPurify.sanitize(html, { ALLOWED_TAGS, ALLOWED_ATTR })
}

export function useAiMarkdown(content: () => string) {
  const rendered = computed(() => renderMarkdown(content()))
  return { rendered }
}
